import {Employee} from "../interfaces/EmployeeInterface";
import { PayPeriod } from "../interfaces/PayPeriodInterface";
import { JobStatus } from "../interfaces/V2Interface";
import TimesheetManager from "../managers/TimesheetManager";

/**
 * Downloads the timecard PDF generated server-side by
 * GET /admin/timesheets/generateTimecard — there is no client-built print HTML.
 * Payroll Timesheet Modifications (M1-B2): for timesheets with
 * `signatureType === 'PAYROLL'` the signature area of that PDF renders exactly
 * "Unavailable to sign" (no attribution, no signature image). That branch lives
 * in the API's timecard generators (API src/util/timecardSignature.ts), not here.
 */
export const printTimesheet = async (employee: Employee, payPeriodID: number, payPeriod: PayPeriod) => {
    const result = await TimesheetManager.openPrintPreview(employee.employeeID, payPeriodID, employee.altEmployeeID, payPeriod);
    if(!result){
      return false;
    } else { return true; }
  }; 

  export const printTimesheetBatch = async (supervisorID: number, payPeriodID: number, altSupervisorID: string, payPeriodObj: any) => {
    const result = await TimesheetManager.openBatchPrintPreview(supervisorID, payPeriodID, altSupervisorID, payPeriodObj);
    if (!result) {
        return false;
    } else { 
        return true; 
    }
};

export const printTimesheetBatchAll = async (
  payPeriodID: number,
  payPeriodObj: any,
  signal?: AbortSignal,
  onProgress?: (jobStatus: JobStatus) => void,
  locationID?: number,
  locationLabel?: string
) => {
  const result = await TimesheetManager.openBatchPrintPreviewAll(payPeriodID, payPeriodObj, signal, onProgress, locationID, locationLabel);
  if (!result) {
      return false;
  } else { 
      return true; 
  }
};